import {
  RuleAttributes,
  RulesEditData,
  SidebarStage,
} from 'api-clients/monolith';

import { APPLICANT_DATA } from './Condition/constants';
import {
  DUMMY_LESSONLY_LESSONS,
  DUMMY_LESSONLY_PATHS,
  DUMMY_NORTHPASS_COURSES,
  DUMMY_NORTHPASS_QUIZZES,
} from './Condition/LearningCondition/LearningCondition.fixtures';
import { AND } from './constants';

export const DUMMY_RULES: RuleAttributes[] = [
  {
    id: 1,
    action_set_attributes: {
      actions_attributes: [
        {
          action_set_type: 'RuleStage::RuleActionSet',
          extra: {},
        },
      ],
    },
    condition_set_attributes: {
      logic: AND,
      conditions_attributes: [
        {
          condition_set_id: undefined,
          extra: {
            comparator: 'ne',
            key: 'why_should_we_hire_you',
            value: 'cause I main Teemo',
            standard: true,
          },
          type: APPLICANT_DATA,
        },
      ],
    },
  },
  {
    id: 2,
    action_set_attributes: {
      actions_attributes: [
        {
          action_set_type: 'RuleStage::RuleActionSet',
          extra: {},
        },
      ],
    },
    condition_set_attributes: {
      conditions_attributes: [
        {
          condition_set_id: undefined,
          extra: {
            comparator: 'eq',
            key: 'date_of_birth',
            value: '1992/01/08',
            standard: true,
          },
          type: APPLICANT_DATA,
        },
      ],
    },
  },
];

export const DUMMY_STAGES: SidebarStage[] = [
  {
    title: 'Lead Research Coordinator #732',
    type: 'BackgroundCheckerStage',
    applicants_count: 0,
    move_rule: {
      target_stage_title: '',
      idle_days_count: 1,
    },
    short_type: 'Background Check',
    external_id: '8d6d1c64-4cbd-42d5-a074-be5e3ff0da9c',
    position: 1,
    additional_info: {
      is_integration_configured: true,
      package_name: 'Driver Pro',
    },
    slug: 'x',
    extra: {},
  },
  {
    title: 'Approved',
    type: 'HiredStage',
    applicants_count: 0,
    move_rule: {
      target_stage_title: '',
      idle_days_count: 1,
    },
    short_type: 'Approved',
    external_id: '9ae71c71-fcea-4134-982d-3dc3d5f5a65f',
    position: 2,
    additional_info: null,
    slug: 'x',
    extra: {},
  },
  {
    title: 'On Hold',
    type: 'ArchivedStage',
    applicants_count: 0,
    move_rule: {
      target_stage_title: '',
      idle_days_count: 1,
    },
    short_type: 'On Hold',
    external_id: 'c428350c-81e4-421a-b437-323263209fef',
    position: 3,
    additional_info: null,
    slug: 'x',
    extra: {},
  },
  {
    title: 'Rejected',
    type: 'RejectedStage',
    applicants_count: 0,
    move_rule: {
      target_stage_title: '',
      idle_days_count: 1,
    },
    short_type: 'Rejected',
    external_id: 'abc1234a-cc11-33aa-xx22-f5a2632e5e3a',
    position: 4,
    additional_info: null,
    slug: 'x',
    extra: {},
  },
];

export const mockPartner1 = {
  value: '31efeb09-96f6-49f9-85ed-dc8f26d79bf6',
  label: 'Schoen-Trantow',
};

export const mockPartner2 = {
  value: 'c8a23f4e-b896-4a45-a705-d9ed136d3137',
  label: 'Summoners-Rift',
};

export const mockRulesFunnelStages = [
  {
    id: '08160c9a-3e6c-4101-ae0b-5cb65ed90344',
    title: 'Rule Something',
    type: 'RuleStage',
    stage_provider: null,
    stage_id: 91,
  },
  {
    id: 'a7cfbc8d-3a1d-4a58-9923-3b9cb4444e5b',
    title: 'Approved',
    type: 'HiredStage',
    stage_provider: null,
    stage_id: 92,
  },
  {
    id: '4eca1558-506a-4f16-801b-c944c10414a9',
    title: 'Rejected',
    type: 'RejectedStage',
    stage_provider: null,
    stage_id: 93,
  },
  {
    id: '8894c288-ac74-4a72-8ae3-ed0a3171a775',
    title: 'On Hold',
    type: 'ArchivedStage',
    stage_provider: null,
    stage_id: 94,
  },
];

export const mockRulesEditData: RulesEditData = {
  allow_read_secure_data: true,
  accurate_stages: [
    {
      id: 'b0fe25fa-707d-4044-9ed4-dc17fd6f94cc',
      stage_id: 600,
      title: 'Accurater',
    },
    {
      id: '264f0bad-b646-45ab-8fb1-399495a543c1',
      stage_id: 601,
      title: 'Omega Accurate Stage',
    },
  ],
  checkr_packages: [
    {
      mvr: false,
      name: 'Tasker Pro',
      screenings: [
        {
          only_supported_in_iframe: null,
          subtype: null,
          supported: true,
          type: 'ssn_trace',
        },
      ],
      slug: 'tasker_pro',
      supports_mvr_first: false,
    },
    {
      mvr: false,
      name: 'Tasker Standard',
      screenings: [
        {
          only_supported_in_iframe: null,
          subtype: null,
          supported: true,
          type: 'national_criminal_search',
        },
      ],
      slug: 'tasker_standard',
      supports_mvr_first: false,
    },
  ],
  checkr_stages: [
    {
      id: 'ddecfe83-6ed6-43da-ad8b-e1c4600f9205',
      stage_id: 500,
      title: 'Checkronie',
    },
    {
      id: 'aaecfe11-2ed6-33da-bd8b-f1c4600f9205',
      stage_id: 501,
      title: 'Super Checkr Stage',
    },
  ],
  data_keys: {
    additional_keys: [],
    custom_keys: [],
    standard_keys: [
      {
        identifier: 'standard:certifications_licenses',
        key: 'certifications_licenses',
        predefined: true,
        options: null,
        secure: false,
        type: 'text_area',
      },
      {
        identifier: 'standard:why_should_we_hire_you',
        key: 'why_should_we_hire_you',
        predefined: true,
        options: null,
        secure: false,
        type: 'text_area',
      },
      {
        identifier: 'standard:data_of_birth',
        key: 'data_of_birth',
        predefined: true,
        options: null,
        secure: false,
        type: 'datepicker',
      },
    ],
  },
  integrations: {
    accurate: true,
    checkr: true,
    lessonly: true,
    onfido: true,
    schoolkeep: true,
    signature_provider: 'white_labeled_hellosign',
    sterling: true,
  },
  funnel_stages: mockRulesFunnelStages,
  condition_statuses: {
    accurate: [
      'not consented',
      'consented',
      'running',
      'clear',
      'consider',
      'needs review',
    ],
    checkr: [
      'clear',
      'consider',
      'pending',
      'canceled',
      'consented',
      'suspended',
      'engaged',
      'post_adverse_action',
      'dispute',
    ],
    compliance: ['IN', 'OUT', 'PENDING_REVIEW'],
    docusign: [
      'Complete',
      'Declined',
      'Incomplete',
      'In Progress',
      'Pending Action',
      'Voided',
    ],
    everify: {
      case_status: [
        'CLOSE_CASE_AND_RESUBMIT',
        'CLOSED',
        'DRAFT',
        'EMPLOYMENT_AUTHORIZED',
        'FINAL_NONCONFIRMATION',
        'MANUAL_REVIEW',
        'PENDING_REFERRAL',
        'PHOTO_MATCH',
        'QUEUED',
        'REFERRED',
        'SCAN_AND_UPLOAD',
        'UNCONFIRMED_DATA',
      ],
      case_eligibility_statement: [
        'EMPLOYMENT_AUTHORIZED',
        'NO_ACTION_FNC',
        'NO_SHOW',
        'NOT_AUTHORIZED_EMPLOYMENT',
        'RESUBMIT_CASE',
      ],
    },
    hellosign: [
      'unopened',
      'opened',
      'signed_by_applicant',
      'signed_by_all_parties',
    ],
    i9_form: [
      'awaiting_employee',
      'awaiting_employer',
      'pending',
      'complete',
      'opted_out',
      'awaiting_authorized_representative',
    ],
    lessonly: ['completed', 'not_completed'],
    onfido: [
      'not consented',
      'consented',
      'pending',
      'clear',
      'consider',
      'reopened',
      'withdrawn',
      'paused',
    ],
    sterling: ['clear', 'consider', 'consented', 'not consented'],
    synergi: [
      'not_started',
      'in_progress',
      'complete',
      'not_qualified',
      'qualified',
      'opted_out',
    ],
    tech_check: ['advance_with_data_missing', 'reject', 'advance'],
    rehire_check: [
      'eligible',
      'not_eligible',
      'no_match',
      'currently_employed',
      'needs_review',
    ],
    w4_federal_form: [
      'awaiting_employee',
      'awaiting_employer',
      'pending',
      'complete',
      'opted_out',
    ],
    white_labeled_hellosign: [
      'unopened',
      'opened',
      'signed_by_applicant',
      'signed_by_all_parties',
    ],
  },
  labels: [
    { label: 'Radical', value: 'Radical' },
    { label: 'Wowza', value: 'Wowza' },
  ],
  openings: [
    {
      active: true,
      id: '31efeb09-96f6-49f9-85ed-dc8f26d79bf6',
      funnel_id: 12,
      slug: 'public-funnel',
      title: 'Public Funnel',
      location: {
        address: '1234 Street St City, ST 12345, Country',
      },
      stages: [
        {
          id: '09f6b7d0-087d-463e-a43f-306d594b2a5d',
          stage_id: 622,
          title: 'In-person Interview',
          type: 'scheduler-stage',
        },
        {
          id: '09f6b7d0-087d-463e-a43f-306d594b2a6e',
          stage_id: 624,
          title: 'Rejected',
          type: 'rejected-stage',
        },
      ],
    },
    {
      active: true,
      id: 'cb4c6ef8-9649-4e22-8d29-90b6e63cdaac',
      funnel_id: 123,
      slug: 'big-funnel',
      title: 'Big Funnel',
      location: {
        address: '1234 Street St City, ST 12345, Country',
      },
      stages: [
        {
          id: 'd06b1c2f-36e7-45b5-a058-4523dc93f04d',
          stage_id: 623,
          title: 'Data Collection',
          type: 'data-collection-stage',
        },
      ],
    },
  ],
  partner_integrations_exist: true,
  partner_detail_keys: [
    {
      value: 'draven',
      label: 'Draven',
      partner_id: '31efeb09-96f6-49f9-85ed-dc8f26d79bf6',
    },
    {
      value: 'teemo',
      label: 'Teemo',
      partner_id: '31efeb09-96f6-49f9-85ed-dc8f26d79bf6',
    },
  ],
  partner_label_keys: [
    {
      value: '1:super',
      label: '[Schoen-Trantow] super',
      partner_id: '31efeb09-96f6-49f9-85ed-dc8f26d79bf6',
      partner_label_key: '1:super',
    },
    {
      value: '1:booyah',
      label: '[Schoen-Trantow] booyah',
      partner_id: '31efeb09-96f6-49f9-85ed-dc8f26d79bf6',
      partner_label_key: '1:booyah',
    },
  ],
  partner_options: [
    {
      value: 'ftn_rules_any',
      label: 'Any option',
      partner_id: '31efeb09-96f6-49f9-85ed-dc8f26d79bf6',
    },
    {
      value: 'ftn_rules_nil',
      label: 'No option',
      partner_id: '31efeb09-96f6-49f9-85ed-dc8f26d79bf6',
    },
    {
      value: 1,
      label: 'First Name',
      partner_id: '31efeb09-96f6-49f9-85ed-dc8f26d79bf6',
    },
  ],
  partner_statuses: [
    { value: 'incomplete', label: 'Incomplete' },
    { value: 'waiting', label: 'Waiting' },
    { value: 'in_progress', label: 'In progress' },
    { value: 'pending_action', label: 'Pending action' },
    { value: 'completed', label: 'Completed' },
    { value: 'error', label: 'Error' },
  ],
  partner_ids: [mockPartner1, mockPartner2],
  sterling_stages: [
    {
      id: 'ewa1234a-cc11-bbbb-1122-f5a2632e5e3a',
      title: 'Sterling Stage',
      stage_id: 1,
    },
    {
      id: 'zzz2167b-zzz1-xaqe-5555-z132632e5e2c',
      title: 'Super Sterling',
      stage_id: 2,
    },
  ],
  signature_templates: [
    {
      template_id: '7959c295-a334-4a08-b2c1-e1668cd6534d',
      title: 'Sample Template 1',
    },
  ],
  lessonly_options: {
    lessons: DUMMY_LESSONLY_LESSONS,
    paths: DUMMY_LESSONLY_PATHS,
  },
  score_card_templates: [
    { id: 1, name: 'Chief Optimization Assistant' },
    { id: 2, name: 'Human Creative Supervisor' },
  ],
  schoolkeep_options: {
    courses: DUMMY_NORTHPASS_COURSES,
    quizzes: DUMMY_NORTHPASS_QUIZZES,
  },
  show_assessment_form_rules: true,
  show_everify_rules: true,
  show_i9_form_rules: true,
  show_tech_check_rules: true,
  tech_check_tiers: ['baseline', 'tier_1', 'tier_2'],
  w4_federal_form_stages: [
    {
      id: '186416ef-ea85-4381-844e-0909091c4a58',
      title: 'W4 Federal Form',
    },
  ],
};
